<script>
  import { onMount, tick } from "svelte";
  import CenteredMenuDialog from "../../../components/layout/menuDialog/variants/CenteredMenuDialog.svelte";
  import MenuDialogSectionEntry from "../../../components/layout/menuDialog/MenuDialogSectionEntry.svelte";
  import MenuDialogSectionEntryTitle from "../../../components/layout/menuDialog/MenuDialogSectionEntryTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import DialogTitle from "../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../components/dialog/DialogBottomControlButton.svelte";
  import ToggleSwitch from "../../../components/input/ToggleSwitch.svelte";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";

  export let GanttStore
  export let onClose

  let dialog

  const {
    ShouldAskConfirmationBeforeReloadingForAutoUpdate,
  } = GanttStore

  function closeDialog() {
    dialog.close()
    onClose()
  }

  onMount(async () => {
    await tick()
    dialog.showModal()
  })
</script>

<CenteredMenuDialog
  bind:dialog={dialog}
  onClose={closeDialog}
>
  <DialogTitle title={translate("frontend:ganttChart.settings.miscSettings.label")} />
  <DialogSplitter />
  <DialogContent>
    <MenuDialogSectionEntry>
      <div class="toggle-switch-container">
        <MenuDialogSectionEntryTitle>
          {translate("frontend:ganttChart.settings.shouldAskConfirmationBeforeReloadingForAutoUpdate.label")}
          <HelpTooltip
            title={translate("frontend:ganttChart.settings.shouldAskConfirmationBeforeReloadingForAutoUpdate.label")}>
            {translate("frontend:ganttChart.settings.shouldAskConfirmationBeforeReloadingForAutoUpdate.tooltip")}
          </HelpTooltip>
        </MenuDialogSectionEntryTitle>
        <div class="toggle-switch">
          <ToggleSwitch
            on={$ShouldAskConfirmationBeforeReloadingForAutoUpdate}
            onChange={async (e) => {
              ShouldAskConfirmationBeforeReloadingForAutoUpdate.set(e.target.checked)
            }}
          />
        </div>
      </div>
    </MenuDialogSectionEntry>
  </DialogContent>
  <DialogSplitter />
  <DialogBottomControls>
    <DialogBottomControlButton type="primary" onClick={onClose}>OK</DialogBottomControlButton>
  </DialogBottomControls>
</CenteredMenuDialog>

<style>
  .toggle-switch-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .toggle-switch {
    margin-left: auto;
  }
</style>
